<template>
    <aside class="d-flex flex-column overflow-visible" :class="[{ 'collapsed': !isHoveringMenu }]"
        @mouseenter="mouseenter" @mouseleave="mouseleave">
        <nav role="navigation" class="flexGrow1">
            <router-link class="logo" :to="{ name: 'dashboard' }">
                <div class="logoCanvas">
                    <img class="logoBig" src="../../assets/images/logo.svg" alt="Pluralo">
                </div>
                <img class="logoSmall" src="/static/images/common/logo_small_red_white.svg" alt="Pluralo">
            </router-link>

            <ul>
                <template v-for="(link, index) in linksNew">
                    <li v-if="link.linkTo === 'settings' && showThisLink(link)" :key="'divider-' + index"
                        class="navDivider" aria-hidden="true"></li>

                    <li v-if="showThisLink(link)" :key="index" class="position-relative no-break-label">
                        <router-link exact active-class="active" :to="{ name: link.linkTo }">
                            <span class="selection"></span>
                            <span class="iconHolder">
                                <i :class="link.icon"></i>
                                <span class="newItemLabel fs-smallest bg-color-1" v-if="showNewLabel(link)">New</span>
                            </span>
                            <span class="label">{{ link.label }}</span>
                        </router-link>
                    </li>
                </template>
            </ul>
        </nav>
    </aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            testeMyAccess: 1,
            isHoveringMenu: false,
            linksNew: [
                {
                    label: 'Dashboard',
                    linkTo: 'dashboard',
                    icon: 'fas fa-home',
                    allowedToAccess: ['admin', 'basic', 'restricted', 'supervisor']
                },
                {
                    label: 'Calendar',
                    linkTo: 'calendar',
                    icon: 'far fa-calendar-alt',
                    allowedToAccess: ['admin', 'basic', 'restricted', 'supervisor', 'viewer']
                },
                {
                    label: 'Reservations',
                    linkTo: 'reservations',
                    icon: 'fas fa-clipboard-check',
                    allowedToAccess: ['admin', 'basic', 'restricted', 'supervisor']
                },
                {
                    label: 'Agents',
                    linkTo: 'agents',
                    icon: 'fas fa-users',
                    allowedToAccess: ['admin', 'supervisor']
                },
                {
                    label: 'My inventory',
                    linkTo: 'inventory',
                    icon: 'fas fa-shapes',
                    allowedToAccess: ['admin']
                },
                {
                    label: 'Invoices',
                    linkTo: 'invoices',
                    icon: 'fas fa-file-invoice-dollar',
                    allowedToAccess: ['admin', 'supervisor'],
                    enabled: this.showInvoiceOption,
                },
                {
                    label: 'Pricing Rules',
                    linkTo: 'rules',
                    icon: 'fas fa-chart-line',
                    allowedToAccess: ['admin', 'supervisor']
                },
                {
                    label: 'Promocodes',
                    linkTo: 'promocodes',
                    icon: 'fas fa-bullhorn',
                    allowedToAccess: ['admin', 'supervisor'],
                    newLabel: {
                        until: '2019-04-30'
                    }
                },
                {
                    label: 'Settings',
                    linkTo: 'settings',
                    icon: 'fas fa-cog',
                    allowedToAccess: ['admin'],
                },
            ],
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getUserAccessType',
            'getShowInvoiceOption',
        ]),
        version() {
            return process.env.CURRENT_VERSION;
        },
        environment() {
            return process.env.NODE_ENV;
        },
    },
    methods: {
        reloadApp() {
            location.reload(true);
        },
        showNewLabel(item) {
            if (!item.newLabel) {
                return false;
            }

            return moment().isBefore(item.newLabel.until);
        },
        showThisLink(link) {
            let doIHavePermissions = this.accessPermissionFilter(link.allowedToAccess);

            if (!link.enabled) {
                return doIHavePermissions;
            } else {
                return doIHavePermissions && link.enabled();
            }
        },
        mouseenter(e) {
            this.isHoveringMenu = true;

            if (document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame')) {
                document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame').classList.add("big");
            }
        },
        mouseleave() {
            this.isHoveringMenu = false;

            if (document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame')) {
                document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame').classList.remove("big");
            }
        },
        showInvoiceOption() {
            return this.getShowInvoiceOption ? this.getShowInvoiceOption : false;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';
@import '~@/assets/scss/_typography.scss';

aside {
    transition: width 280ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 280ms ease;
    color: rgba($lightest, 0.72);
    background: $darkest;
    width: 15rem;
    position: relative;
    z-index: 10;
    box-shadow: 8px 0 24px rgba(0, 0, 0, 0.18);

    nav {
        transition: width 280ms cubic-bezier(0.4, 0, 0.2, 1);
        width: 15rem;

        >.logo {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 48px;
            margin: 0.6rem 0 1.5rem;

            .logoBig {
                height: 26px;
                transition: height 280ms cubic-bezier(0.4, 0, 0.2, 1); // optional: smooth it too
            }

            .logoSmall {
                display: none;
            }
        }

        >ul {
            padding: 0.5rem 0.75rem;

            >li {
                display: block;
                margin-bottom: 0.125rem;

                >a {
                    display: flex;
                    align-items: center;
                    height: 44px;
                    border-radius: 8px;
                    color: rgba($lightest, 0.72);
                    transition: background 180ms ease, color 180ms ease;

                    &:hover {
                        background: rgba($lightest, 0.06);
                        color: $lightest;
                    }

                    .selection {
                        flex-shrink: 0;
                        width: 3px;
                        height: 1.5rem;
                        margin-right: 0.875rem;
                        border-radius: 3px;
                        background: transparent;
                        transform: scaleY(0);
                        transition: background 180ms ease, transform 220ms cubic-bezier(0.34, 1.56, 0.64, 1);
                    }

                    .iconHolder {
                        position: relative;
                        flex-shrink: 0;
                        width: 20px;
                        text-align: center;
                        font-size: 1.0625rem;
                        transition: color 180ms ease;
                    }

                    .label {
                        margin-left: 0.875rem;
                        font-size: 0.9375rem;
                        letter-spacing: 0.01em;
                        white-space: nowrap;
                        opacity: 1;
                        transition: opacity 160ms ease 60ms;
                    }

                    &.active {
                        @extend .bold;
                        color: #00a9f0;
                        background: rgba($lightest, 0.08);

                        .selection {
                            background: #00a9f0;
                            transform: scaleY(1);
                        }

                        .iconHolder {
                            color: #00a9f0;
                        }
                    }

                    &:active,
                    &:focus {
                        color: $lightest;
                        text-decoration: none;
                    }

                    &:focus-visible {
                        outline: 2px solid #00a9f0;
                        outline-offset: -2px;
                    }
                }
            }
        }
    }
}

aside.collapsed {
    width: 4.7rem;
    box-shadow: none;

    nav {
        width: 4.7rem;

        .logo {
            width: 4.7rem;

            .logoCanvas {
                width: 48px;
                overflow: hidden;
                padding-left: 4px;
                display: inline-block;

                .logoBig {
                    height: 34px;
                }
            }
        }

        ul {
            padding: 0.5rem 0.5rem;

            li {
                a {
                    justify-content: center;

                    .selection {
                        position: absolute;
                        left: 0;
                        margin-right: 0;
                    }

                    .iconHolder {
                        width: auto;
                    }

                    .label {
                        width: 0;
                        margin-left: 0;
                        opacity: 0;
                        overflow: hidden;
                        transition: opacity 100ms ease;
                    }

                    &.active .selection {
                        left: -0.5rem;
                    }
                }
            }
        }
    }

    .bottomInfoBig {
        display: none;
    }

    .bottomInfoSmall {
        display: block;
    }
}

.navDivider {
    height: 1px;
    margin: 0.625rem 1rem;
    background: rgba($lightest, 0.08);
}

.newItemLabel {
    position: absolute;
    bottom: -13px;
    left: -6px;
    padding: 1px 4px;
    border-radius: 4px;
    line-height: 1.1em;
    font-size: 0.5625rem;
}

.overflow-visible {
    overflow: visible;
}

.no-break-label {
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// Sidebar.vue?583256b8